import {
	PdfFieldFlag,
	useDefaultRequiredFieldsProvider,
} from '@/data/requiredFormFields'
import { DocumentType } from '@/enums/DocumentType'
import { useSessionDocumentsStore } from '@/stores/sessionDocuments'
import { Frequency } from '@precoa/calculator-sdk'

// TexasRequiredFieldsProvider is a composable that provides the required fields for the Texas enrollment form.
export const useTexasRequiredFieldsProvider = () => {
	const sessionDocumentsStore = useSessionDocumentsStore()
	const defaultProvider = useDefaultRequiredFieldsProvider()

	const getRequiredCheckBoxConfig = (documentType: DocumentType) => {
		const result = defaultProvider.getRequiredCheckBoxConfig(documentType)

		const planHolder = sessionDocumentsStore.currentPlan

		//required fields specific to texas enrollment form
		if (
			documentType === DocumentType.EnrollmentForm &&
			planHolder?.insurance.paymentFrequency !== Frequency.OneTime
		) {
			result.push(
				{
					regex: /healthQuestions2\w*/,
					name: 'Health Question 2',
				},
				{
					regex: /healthQuestions3\w*/,
					name: 'Health Question 3',
				}
			)
		}

		return result
	}

	const getRequiredTextFieldConfig = defaultProvider.getRequiredTextFieldConfig

	// for texas health questions 2 and 3 are required if the payment frequency is not one time
	const areAllHealthQuestionsRequired = () => {
		return (
			sessionDocumentsStore.currentDocument?.meta.type ===
				DocumentType.EnrollmentForm &&
			sessionDocumentsStore.currentPlan?.insurance.paymentFrequency !==
				Frequency.OneTime
		)
	}

	const getRequiredFieldsConfig = (
		documentType: DocumentType | undefined
	): { name: string; flag: number }[] => {
		const flag = areAllHealthQuestionsRequired() ? PdfFieldFlag.Required : 0

		return [
			...defaultProvider.getRequiredFieldsConfig(documentType),
			{ name: 'healthQuestions2YesTXCheck', flag },
			{ name: 'healthQuestions2NoTXCheck', flag },
			{ name: 'healthQuestions3YesTXCheck', flag },
			{ name: 'healthQuestions3NoTXCheck', flag },
		]
	}

	return {
		getRequiredCheckBoxConfig,
		getRequiredTextFieldConfig,
		getRequiredFieldsConfig,
	}
}
